module.exports = __webpack_public_path__ + "img/1_036.6d0dbb9b.jpg";